import React, { useState } from "react";
import {
  FieldLabel,
  SelectInput,
  TextInput,
} from "../../../components/ui/FormControls";
import type { TradeOption } from "../types";

const OTHER_TRADE_SLUG = "other";

type OrgTradeFieldsProps = {
  tradeOptions: TradeOption[];
  tradeSlug?: string | null;
  tradeType?: string | null;
  namePrefix?: string;
  onTradeChange?: (next: { tradeSlug: string; tradeType: string }) => void;
};

export const OrgTradeFields: React.FC<OrgTradeFieldsProps> = ({
  tradeOptions,
  tradeSlug,
  tradeType,
  namePrefix = "organization",
  onTradeChange,
}) => {
  const [selectedSlug, setSelectedSlug] = useState(tradeSlug ?? "");
  const [customTrade, setCustomTrade] = useState(tradeType ?? "");
  const showCustomTrade = selectedSlug === OTHER_TRADE_SLUG;

  return (
    <>
      <div className="mb-4">
        <FieldLabel htmlFor={`${namePrefix}_trade_slug`}>Trade</FieldLabel>
        <SelectInput
          id={`${namePrefix}_trade_slug`}
          name={`${namePrefix}[trade_slug]`}
          defaultValue={tradeSlug ?? ""}
          required
          onChange={(event) => {
            const nextSlug = event.target.value;
            setSelectedSlug(nextSlug);
            onTradeChange?.({
              tradeSlug: nextSlug,
              tradeType: nextSlug === OTHER_TRADE_SLUG ? customTrade : "",
            });
          }}
        >
          <option value="">Select your trade…</option>
          {tradeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </SelectInput>
      </div>
      {showCustomTrade ? (
        <div className="mb-4">
          <FieldLabel htmlFor={`${namePrefix}_trade_type`}>
            Your trade
          </FieldLabel>
          <TextInput
            id={`${namePrefix}_trade_type`}
            name={`${namePrefix}[trade_type]`}
            defaultValue={tradeType ?? ""}
            placeholder="e.g. custom home services"
            required
            maxLength={80}
            onChange={(event) => {
              const nextType = event.target.value;
              setCustomTrade(nextType);
              onTradeChange?.({
                tradeSlug: selectedSlug,
                tradeType: nextType,
              });
            }}
          />
        </div>
      ) : null}
    </>
  );
};
